import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/InventoryUsageReport/Filter'

export default createListViewComponent({
  entityName: entityNames.inventoryUsageReport,
  filterTemplateType: 'InventoryUsageReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'MonthToDate' } }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
})(Filter)
